<div class="grid grid-liquid car-policy">
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-claim-small" class="xsmall"></open-svg-icon>
      <h2>Cover</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Start</span>
        <span class="stat-block-value">{{ policyDetails.startDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">End</span>
        <span class="stat-block-value">{{ policyDetails.endDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Basic excess</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.excess" [precision]="0" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Minimum age</span>
        <span class="stat-block-value">{{ policyDetails.minAge }}</span>
      </div>
      <div class="cell flex flex-column stat-block" [ngClass]="{ 'cell-large-col-span-8': policyDetails.firstPayableInvoice.amount, 'cell-large-col-span-4': !policyDetails.firstPayableInvoice.amount }">
        <span class="stat-block-title">Payment frequency</span>
        <span class="stat-block-value">{{ policyDetails.paymentFrequency.label }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngIf="policyDetails.firstPayableInvoice.amount">
        <span class="stat-block-title">First payment</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.firstPayableInvoice" size="inherit"></open-price> (Inc GST)</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">{{ policyDetails.isUpfront ? 'Annual' : 'Ongoing monthly' }} payment</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.premium" size="inherit"></open-price> (Inc GST)</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngIf="policyDetails.extras?.length">
        <span class="stat-block-title">Optional extras</span>
        <ul>
          <li *ngFor="let extra of policyDetails.extras"><span class="stat-block-value">{{ extra }}</span></li>
        </ul>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngIf="policyDetails.isPayd">
        <span class="stat-block-title">Pay As You Drive Cover Kilometres</span>
        <span class="stat-block-value">{{ policyDetails.isPayd ? policyDetails.kmsKiloPayd : policyDetails.kmsKilo }},000 kms</span>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="options-hirecar-small" class="xsmall"></open-svg-icon>
      <h2>Car</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Registration number</span>
        <span class="stat-block-value">{{ policyDetails.carRego }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Insured for</span>
        <span class="stat-block-value" *ngIf="policyDetails.isMarketValue">Market Value'</span>
        <span class="stat-block-value" *ngIf="!policyDetails.isMarketValue"><open-price [price]="policyDetails.sumInsured" [precision]="0" size="inherit"></open-price> (agreed value)</span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block">
        <span class="stat-block-title">Car</span>
        <span class="stat-block-value">{{ policyDetails.carDetails }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Finance</span>
        <span class="stat-block-value" *ngIf="!policyDetails.isRaptorial">{{ policyDetails.finance.type !== 0 ? policyDetails.finance.label : 'No' }}</span>
        <span class="stat-block-value" *ngIf="policyDetails.isRaptorial">{{ policyDetails.finance }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngIf="policyDetails.finance?.length">
        <span class="stat-block-title">Finance Provider</span>
        <span class="stat-block-value">{{ policyDetails.financeProvider }}</span>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-drivers-small" class="xsmall"></open-svg-icon>
      <h2>Drivers</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-8 flex flex-column stat-block">
        <span class="stat-block-title">Main driver</span>
        <span class="stat-block-value">{{ policyDetails.mainDriver.first_name }} {{ policyDetails.mainDriver.last_name }}</span>
        <span class="stat-block-desc">{{ policyDetails.mainDriver.gender | gender }}, {{ policyDetails.mainDriver.dob | age }}</span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block" *ngIf="policyDetails.additionalDrivers?.length">
        <span class="stat-block-title">Additional driver</span>
        <div class="grid grid-large-8 margin-none">
          <div class="cell cell-large-col-span-4 flex flex-column" *ngFor="let driver of policyDetails.additionalDrivers">
            <span class="stat-block-value">{{ driver.first_name }} {{ driver.last_name }}</span>
            <span class="stat-block-desc">{{ driver.gender | gender }}, {{ driver.dob | age }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box" *ngIf="policyDetails.authorisedPersons?.length">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-authoriseddrivers-small" class="xsmall"></open-svg-icon>
      <h2>Authorised contacts</h2>
    </div>
    <div class="cell cell-large-col-span-8 flex flex-column stat-block">
      <span class="stat-block-title">Authorised contact</span>
      <div class="grid grid-large-8 margin-none">
        <div class="cell cell-large-col-span-4 flex flex-column" *ngFor="let person of policyDetails.authorisedPersons">
          <span class="stat-block-value">{{ person.first_name || person.other_authorised_contact_given_name }} {{ person.last_name || person.other_authorised_contact_last_name }}</span>
          <span class="stat-block-desc">{{ (person.dob || person.other_authorised_contact_dob) | displayDate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
